function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 70,
  cy: 70,
  r: 70,
  fill: "#0085FF",
  fillOpacity: 0.08
});
var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#empty-documents-state_svg__filter0_d_2_44)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 31,
  y: 47,
  width: 140,
  height: 58,
  rx: 1.532,
  fill: "#fff"
}));
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M46.583 53h5.82c.055 0 .097.013.125.054l2.416 2.693c.042.04.056.08.056.12v7.584c0 .147-.07.281-.167.388a.575.575 0 01-.402.161H46.57a.63.63 0 01-.403-.16.536.536 0 01-.167-.39v-9.914c0-.147.07-.281.167-.389a.685.685 0 01.416-.147zm5.75.348h-5.75c-.055 0-.097.027-.139.054a.169.169 0 00-.055.134v9.901c0 .054.028.094.055.134.042.04.084.054.14.054h7.86c.056 0 .098-.027.14-.054a.169.169 0 00.055-.134v-7.503l-2.306-2.586z",
  fill: "#0085FF"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M54.794 56l-2.584-.013c-.105 0-.195-.08-.195-.172v-.013L52 53.172c0-.093.09-.172.195-.172.06 0 .105.013.135.053l2.614 2.656c.075.066.075.172 0 .251-.03.027-.09.04-.15.04zm-2.388-.357h1.99l-1.99-2.048v2.048z",
  fill: "#0085FF"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  fill: "#0085FF",
  d: "M48 58.5h5v4h-5z"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M50.262 61.627l1.392-1.392s.332-.332-.066-.73c-.398-.397-.729-.066-.729-.066l-1.392 1.392s-.264.267 0 .53c.278.28.53 0 .53 0l1.26-1.259c.132-.132.199-.199.066-.331-.133-.133-.199-.066-.331.066l-1.194 1.193",
  stroke: "#0085FF",
  strokeWidth: 0.188,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M60.583 53h5.82c.055 0 .097.013.125.054l2.416 2.693c.042.04.056.08.056.12v7.584c0 .147-.07.281-.167.388a.575.575 0 01-.402.161H60.57a.63.63 0 01-.403-.16.536.536 0 01-.167-.39v-9.914c0-.147.07-.281.167-.389a.685.685 0 01.416-.147zm5.75.348h-5.75c-.055 0-.097.027-.139.054a.169.169 0 00-.055.134v9.901c0 .054.028.094.055.134.042.04.084.054.14.054h7.86c.056 0 .098-.027.14-.054a.169.169 0 00.055-.134v-7.503l-2.306-2.586z",
  fill: "#A0AFBE"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M68.793 56l-2.583-.013c-.105 0-.195-.08-.195-.172v-.013L66 53.172c0-.093.09-.172.195-.172.06 0 .105.013.135.053l2.614 2.656c.075.066.075.172 0 .251-.03.027-.09.04-.15.04zm-2.388-.357h1.99l-1.99-2.048v2.048z",
  fill: "#A0AFBE"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  fill: "#DBDFE5",
  d: "M62 58.5h5v4h-5z"
});
var _ref0 = /*#__PURE__*/React.createElement("path", {
  d: "M64.262 61.627l1.392-1.392s.332-.332-.066-.73c-.398-.397-.729-.066-.729-.066l-1.392 1.392s-.264.267 0 .53c.278.28.53 0 .53 0l1.26-1.259c.132-.132.199-.199.066-.331-.133-.133-.199-.066-.331.066l-1.194 1.193",
  stroke: "#A0AFBE",
  strokeWidth: 0.188,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref1 = /*#__PURE__*/React.createElement("path", {
  d: "M74.583 53h5.82c.055 0 .097.013.125.054l2.416 2.693c.042.04.056.08.056.12v7.584c0 .147-.07.281-.167.388a.575.575 0 01-.402.161H74.57a.63.63 0 01-.403-.16.536.536 0 01-.167-.39v-9.914c0-.147.07-.281.167-.389a.685.685 0 01.416-.147zm5.75.348h-5.75c-.055 0-.097.027-.138.054a.169.169 0 00-.056.134v9.901c0 .054.028.094.056.134.041.04.083.054.138.054h7.861c.056 0 .098-.027.14-.054a.169.169 0 00.055-.134v-7.503l-2.306-2.586z",
  fill: "#A0AFBE"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M82.793 56l-2.583-.013c-.105 0-.195-.08-.195-.172v-.013L80 53.172c0-.093.09-.172.195-.172.06 0 .105.013.135.053l2.614 2.656c.075.066.075.172 0 .251-.03.027-.09.04-.15.04zm-2.388-.357h1.99l-1.99-2.048v2.048z",
  fill: "#A0AFBE"
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  fill: "#DBDFE5",
  d: "M76 58.5h5v4h-5z"
});
var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M78.262 61.627l1.392-1.392s.332-.332-.066-.73c-.398-.397-.729-.066-.729-.066l-1.392 1.392s-.264.267 0 .53c.278.28.53 0 .53 0l1.26-1.259c.132-.132.199-.199.066-.331-.133-.133-.199-.066-.331.066l-1.194 1.193",
  stroke: "#A0AFBE",
  strokeWidth: 0.188,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M88.583 53h5.82c.055 0 .097.013.125.054l2.416 2.693c.042.04.056.08.056.12v7.584c0 .147-.07.281-.167.388a.575.575 0 01-.402.161H88.57a.63.63 0 01-.403-.16.536.536 0 01-.167-.39v-9.914c0-.147.07-.281.167-.389a.685.685 0 01.416-.147zm5.75.348h-5.75c-.055 0-.097.027-.138.054a.169.169 0 00-.056.134v9.901c0 .054.028.094.056.134.041.04.083.054.138.054h7.861c.056 0 .098-.027.14-.054a.169.169 0 00.055-.134v-7.503l-2.306-2.586z",
  fill: "#A0AFBE"
});
var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M96.793 56l-2.583-.013c-.105 0-.195-.08-.195-.172v-.013L94 53.172c0-.093.09-.172.195-.172.06 0 .105.013.135.053l2.614 2.656c.075.066.075.172 0 .251-.03.027-.09.04-.15.04zm-2.388-.357h1.99l-1.99-2.048v2.048z",
  fill: "#A0AFBE"
});
var _ref15 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  fill: "#DBDFE5",
  d: "M90 58.5h5v4h-5z"
});
var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M92.262 61.627l1.392-1.392s.332-.332-.066-.73c-.398-.397-.729-.066-.729-.066l-1.392 1.392s-.264.267 0 .53c.278.28.53 0 .53 0l1.26-1.259c.132-.132.199-.199.066-.331-.133-.133-.199-.066-.331.066l-1.194 1.193",
  stroke: "#A0AFBE",
  strokeWidth: 0.188,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref17 = /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 49,
  r: 14,
  fill: "#DBDFE5",
  stroke: "#fff",
  strokeWidth: 2
});
var _ref18 = /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 49,
  r: 13,
  fill: "#DBDFE5"
});
var _ref19 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#empty-documents-state_svg__a)",
  fill: "#A0AFBE"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 62,
  r: 13
}), /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 44.864,
  r: 6.275,
  stroke: "#DBDFE5",
  strokeWidth: 1.914
}));
var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M53.167 73h11.639c.11 0 .194.027.25.107l4.833 5.386c.083.08.111.161.111.242V93.9c0 .295-.139.563-.333.777a1.15 1.15 0 01-.806.322H53.14c-.306 0-.583-.134-.806-.322a1.07 1.07 0 01-.333-.777v-19.83c0-.294.139-.562.333-.776a1.37 1.37 0 01.834-.295zm11.5.697h-11.5c-.111 0-.195.053-.278.107a.338.338 0 00-.111.268v19.802c0 .108.055.188.11.269.084.08.168.107.279.107h15.722c.111 0 .194-.054.278-.108a.338.338 0 00.11-.267V78.867l-4.61-5.171z",
  fill: "#0085FF"
});
var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M69.587 79l-5.166-.026c-.21 0-.391-.159-.391-.344v-.026l-.03-5.26c0-.185.18-.344.39-.344.12 0 .21.026.27.106l5.227 5.313c.15.132.15.343 0 .502-.06.053-.18.079-.3.079zm-4.776-.714h3.98l-3.98-4.097v4.097z",
  fill: "#0085FF"
});
var _ref22 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  fill: "#0085FF",
  d: "M56 84h10v8H56z"
});
var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M60.525 90.254l2.784-2.784s.663-.663-.133-1.459c-.795-.795-1.458-.132-1.458-.132l-2.785 2.784s-.527.533 0 1.06c.557.558 1.061 0 1.061 0l2.52-2.518c.264-.266.397-.398.132-.663-.265-.266-.398-.133-.663.132l-2.387 2.387",
  stroke: "#0085FF",
  strokeWidth: 0.375,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref24 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  fill: "#0085FF",
  d: "M80 80h46v8H80zM80 91h82v8H80zM80 69h70v8H80z"
});
var _ref25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "empty-documents-state_svg__filter0_d_2_44",
  x: 23,
  y: 41,
  width: 156,
  height: 74,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2_44"
}), /*#__PURE__*/React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow_2_44",
  result: "shape"
})));
function SvgEmptyDocumentsState(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 140,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref0, _ref1, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, /*#__PURE__*/React.createElement("mask", {
    id: "empty-documents-state_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 36,
    width: 26,
    height: 26
  }, _ref18), _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25);
}
export default SvgEmptyDocumentsState;